// extracted by mini-css-extract-plugin
export default {"root":"Register_root__LJP5R","title":"Register_title__slMqk","form":"Register_form__L2QG8","button":"Register_button__zai2v","link":"Register_link__tUzhf"};